import { useTenant } from '@alison/whitelabel/react';
import Box from '@mui/material/Box';
import { type ReactNode, useEffect, useState } from 'react';
import { ASK_ALISON_THINKING_FRAMES } from '../../assets/ask-alison-thinking.js';

const FRAME_DURATION_MS = 500;
const FRAME_FADE_MS = 250;

export function AskAlisonThinkingIcon(): ReactNode {
  const { providerName } = useTenant();
  const [frameIndex, setFrameIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrameIndex((current) => (current + 1) % ASK_ALISON_THINKING_FRAMES.length);
    }, FRAME_DURATION_MS);
    return () => clearInterval(interval);
  }, []);

  const previousFrameIndex =
    (frameIndex - 1 + ASK_ALISON_THINKING_FRAMES.length) % ASK_ALISON_THINKING_FRAMES.length;

  return (
    <Box sx={{ position: 'relative', width: 32, height: 32 }}>
      <Box
        component="img"
        src={ASK_ALISON_THINKING_FRAMES[previousFrameIndex]}
        alt=""
        sx={{ position: 'absolute', inset: 0, width: 32, height: 32 }}
      />
      <Box
        key={frameIndex}
        component="img"
        src={ASK_ALISON_THINKING_FRAMES[frameIndex]}
        alt={`${providerName} is thinking`}
        sx={{
          position: 'absolute',
          inset: 0,
          width: 32,
          height: 32,
          animation: `askAlisonThinkingFrameFadeIn ${FRAME_FADE_MS}ms ease forwards`,
          '@keyframes askAlisonThinkingFrameFadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        }}
      />
    </Box>
  );
}
